export const modules = {
  clipboard: {
    matchVisual: false, // prevents unnecessary blank lines before lists (FDHA-8941)
  },
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
    ['blockquote', 'link'],
  ],
};
